<template>
  <section class="careers-benefits locked">
    <div class="page-container careers-benefits__inner relative">
      <h2 class="careers-benefits__title">We&rsquo;re competitive. So&nbsp;are our benefits</h2>
      <p class="careers-benefits__subtitle">
        At&nbsp;Bravado, investing in&nbsp;our team isn&rsquo;t just a&nbsp;talking point. We&nbsp;provide competitive
        benefits and a&nbsp;subsidized modern tech lifestyle to&nbsp;our employees.
      </p>

      <div class="careers-benefits__cards grid-row justify-center">
        <div v-for="benefit in benefits" :key="benefit.color + benefit.title" class="col-3 pt0 careers-benefits__card">
          <BravadoCard :size="24" :item="benefit" variant="sss" />
        </div>
      </div>

      <ul class="grid-row careers-benefits__extra-wrapper">
        <li v-for="(extraBenefit, key) in extraBenefits" :key="key" class="col-shrink py0 pr0">
          <div class="careers-benefits__extra">
            <img v-if="extraBenefit.image" width="30" height="30" :src="extraBenefit.image" :alt="extraBenefit.title" />
            {{ extraBenefit.title }}
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>

<script lang="ts">
import Vue from 'vue';
import { benefits, extraBenefits } from '../constants';
import BravadoCard from '~/components/partials/landings/ui/BravadoItemCard.vue';

export default Vue.extend({
  name: 'CareersBenefits',
  components: { BravadoCard },
  data() {
    return {
      benefits,
      extraBenefits,
    };
  },
});
</script>

<style lang="scss" scoped>
.careers-benefits {
  padding: 46px 18px 75px;
  margin: 0;
  z-index: 1;

  ul {
    list-style-type: none;
    padding: 0;
  }

  @include mq('sm') {
    padding: 70px 0 54px;
    margin: 114px 0 0;
  }

  &__inner {
    padding: 0;

    @include mq('sm') {
      padding: 0 16px;
    }
  }

  &__title {
    color: #161a21;
    max-width: 80%;
    margin: 0 0 16px;

    @include bravado-h4;

    @include mq('sm') {
      margin: 0 0 24px;

      @include bravado-h1;
    }
  }

  &__subtitle {
    max-width: 720px;
    margin-bottom: 37px;

    @include body;

    @include mq('sm') {
      margin-bottom: 55px;

      @include bravado-super-headline;
    }
  }

  &__cards {
    display: grid;
    justify-content: center;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 12px;
    grid-row-gap: 16px;
    margin-bottom: 50px;
    margin-top: 0;
    padding: 0 18px;

    .col-3 {
      flex: 0 0 50%;
      min-width: 50%;
      max-width: 50%;
    }

    @include mq('sm') {
      display: flex;
      grid-column-gap: 0;
      grid-row-gap: 0;
      margin-bottom: 45px;
      margin-top: -16px;
      min-width: 410px;
      padding: 0;

      .col-3 {
        flex: 0 0 25%;
        min-width: 25%;
        max-width: 25%;
      }
    }
  }

  &__card.col-3 {
    max-width: none;
    min-width: auto;
    padding: 0;

    .bravado-card--sss {
      min-width: auto;

      @include mq('sm') {
        min-width: 192px;
      }
    }

    ::v-deep .bravado-card__title {
      font-size: 15px;
    }

    ::v-deep .bravado-card__subtitle {
      line-height: 1.15;

      @include mq('sm') {
        line-height: 20px;
      }
    }

    @include mq('sm') {
      max-width: 50%;
      padding: 16px;
    }
  }

  &__extra {
    background: #fff;
    box-shadow: 0 1px 6px rgba(129, 132, 150, 0.15);
    border-radius: 8px;
    color: var(--gray-70);
    padding: 0 15px;
    display: inline-flex;
    height: 58px;
    align-items: center;
    margin: 0 0 12px 0;
    font-size: 15px;
    line-height: 20px;
    max-width: 300px;

    @include mq('sm') {
      padding: 14px 21px;
      max-width: 530px;

      @include bravado-headline;
    }

    img {
      max-width: 30px;
      margin-right: 10px;
    }

    &-wrapper {
      @include mq('sm') {
        min-width: 590px;
      }
    }
  }
}
</style>
